export default __webpack_public_path__ + "static/media/air.89571118.mp3";